module.exports = __webpack_public_path__ + "img/2.f8f1011b.png";